import { CostCenter2, Expense } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"
import { isSplitPropertiesSame } from "../../../../../shared/utils/expense.utils"

interface CostCenter2Props {
    expense: Expense
    costCenter2?: CostCenter2
}

export const CostCenter2Field = ({ expense, costCenter2 }: CostCenter2Props) => {
    const { t } = useTranslation()

    const splitsHasAnyCostCenter2 = expense.splits.some((s) => !!s.costCenter2)
    const isUniform = isSplitPropertiesSame(expense.splits)

    if (costCenter2 || (expense.splits.length > 1 && splitsHasAnyCostCenter2)) {
        return (
            <li>
                <span className="title">{t("label:cost_center_2")}</span>
                <span className="text truncate max-w-180 text-right">{isUniform.costCenter2 && costCenter2 ? costCenter2.name : t("label:splitted")}</span>
            </li>
        )
    }

    return null
}
